module.exports = __webpack_public_path__ + "8ffbeecd447d17ccdf5cc75e2d866376.jpg";